const APTITUDES = {
  AGRICULTURAL: 'Agrícola'
}

module.exports = {
  APTITUDES
}